import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[noWhitespace]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NoWhitespaceValidatorDirective,
      multi: true
    }
  ]
})
export class NoWhitespaceValidatorDirective implements Validator {

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return { whitespace: true };

    // Trim spaces
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }
}
